import React from "react";
import {
  hasSkinHeading,
  type LaunchableSkin,
} from "components/Launchables/DeployRedesign/shared/content/skins/registry";
import { SkinHeading } from "components/Launchables/DeployRedesign/shared/content/skins/SkinHeading";

interface LaunchableHeadingProps {
  activeSkin: LaunchableSkin | null;
  name?: string | null;
  description?: string | null;
}

export const LaunchableHeading: React.FC<LaunchableHeadingProps> = ({
  activeSkin,
  name,
  description,
}) => {
  if (hasSkinHeading(activeSkin)) {
    return <SkinHeading skin={activeSkin} />;
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight text-white sm:text-3xl">
        {name || ""}
      </h1>
      <p className="mt-2 max-w-3xl whitespace-pre-line text-sm leading-6 text-secondary">
        {description || "A ready-to-run environment configured by its author."}
      </p>
    </div>
  );
};
